@if (!isLoading && isRequired) {
<div class="card">
  <div class="card-header">Page Optimization Audit</div>
  <div class="card-body">
    <div class="row g-0">
      @if (isReadOnly) {
      <div class="col-md-6 border-end pe-3">
        <ul class="list-group list-group-flush">
          <ng-container *ngTemplateOutlet="auditItemReadOnly; context: { formControl: headingsStructureControl, helpKey: 'PageOptimizationAudit_HeadingsStructure', label: 'Headings Structure' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItemReadOnly; context: { formControl: metaRobotsControl, helpKey: 'PageOptimizationAudit_MetaRobots', label: 'Meta Robots' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItemReadOnly; context: { formControl: conversionLanguageInPlaceControl, helpKey: 'PageOptimizationAudit_ConversionLanguageInPlace', label: 'Conversion Language in Place' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItemReadOnly; context: { formControl: duplicateContentControl, helpKey: 'PageOptimizationAudit_DuplicateContentCanonicalTag', label: 'Duplicate Content (Canonical Tag)' }"></ng-container>
        </ul>
      </div>
      <div class="col-md-6 ps-3">
        <ul class="list-group list-group-flush">
          <ng-container *ngTemplateOutlet="auditItemReadOnly; context: { formControl: robotsTxtFileControl, helpKey: 'PageOptimizationAudit_RobotsTxtFile', label: 'Robots.txt File' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItemReadOnly; context: { formControl: redirectsControl, helpKey: 'PageOptimizationAudit_Redirects', label: 'Redirects' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItemReadOnly; context: { formControl: imageOptimizationControl, helpKey: 'PageOptimizationAudit_ImageOptimization', label: 'Image Optimization' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItemReadOnly; context: { formControl: urlStructureControl, helpKey: 'PageOptimizationAudit_UrlStructure', label: 'URL Structure' }"></ng-container>
        </ul>
      </div>
      } @else {
      <div class="col-md-6 border-end pe-3">
        <ul class="list-group list-group-flush">
          <ng-container *ngTemplateOutlet="auditItem; context: { formControl: headingsStructureControl, helpKey: 'PageOptimizationAudit_HeadingsStructure', label: 'Headings Structure' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItem; context: { formControl: metaRobotsControl, helpKey: 'PageOptimizationAudit_MetaRobots', label: 'Meta Robots' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItem; context: { formControl: conversionLanguageInPlaceControl, helpKey: 'PageOptimizationAudit_ConversionLanguageInPlace', label: 'Conversion Language in Place' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItem; context: { formControl: duplicateContentControl, helpKey: 'PageOptimizationAudit_DuplicateContentCanonicalTag', label: 'Duplicate Content (Canonical Tag)' }"></ng-container>
        </ul>
      </div>
      <div class="col-md-6 ps-3">
        <ul class="list-group list-group-flush">
          <ng-container *ngTemplateOutlet="auditItem; context: { formControl: robotsTxtFileControl, helpKey: 'PageOptimizationAudit_RobotsTxtFile', label: 'Robots.txt File' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItem; context: { formControl: redirectsControl, helpKey: 'PageOptimizationAudit_Redirects', label: 'Redirects' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItem; context: { formControl: imageOptimizationControl, helpKey: 'PageOptimizationAudit_ImageOptimization', label: 'Image Optimization' }"></ng-container>
          <ng-container *ngTemplateOutlet="auditItem; context: { formControl: urlStructureControl, helpKey: 'PageOptimizationAudit_UrlStructure', label: 'URL Structure' }"></ng-container>
        </ul>
      </div>
      }
    </div>
  </div>
</div>
}

<ng-template #auditItem let-formControl="formControl" let-helpKey="helpKey" let-label="label">
  <li class="list-group-item ps-2 d-flex justify-content-between align-items-center" [formValidation]="formControl">
    <span>{{ label }}
      <app-components-helptext [key]="helpKey"></app-components-helptext>
    </span>
    <shared-components-customchoice [formControl]="formControl" [choiceTrue]="'Pass'" [choiceFalse]="'Fail'"></shared-components-customchoice>
  </li>
</ng-template>

<ng-template #auditItemReadOnly let-formControl="formControl" let-helpKey="helpKey" let-label="label">
  <li class="list-group-item ps-2 d-flex justify-content-between align-items-center">
    <span>{{ label }}
      <app-components-helptext [key]="helpKey"></app-components-helptext>
    </span>
    @if (formControl.value === true) {
      <button class="btn btn-success btn-75" disabled>Pass</button>
    } @else {
      <button class="btn btn-secondary btn-75" disabled>Fail</button>
    }
  </li>
</ng-template>